module.exports = __webpack_public_path__ + "static/media/brand-story-banner1.0588fb2e.jpg";